var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommandCenterDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8276 15.5863L16.7586 14.4829M18.5 19L16.7586 17M15.7931 18.4829L14.8276 16.5518M6.13794 8.55183L7.93104 9.65528M6.4138 6.06907L7.93104 7.58632M8.75863 5.79321L10 7.72425",
    stroke: "#4D4D4D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2428 13.2414L14.4152 4L12.3462 10.7586H17.5876L10.4152 20L12.3462 13.2414H7.2428Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 9.08961 21.8697 6.44322 20.0242 4.47582L20.7316 3.76838C22.758 5.91703 24 8.81347 24 12C24 18.6274 18.6274 24 12 24C8.3044 24 4.99899 22.3294 2.79773 19.7023L3.5 19L3.43628 18.9044C5.45272 21.4023 8.53978 23 12 23ZM12 0C14.676 0 17.1475 0.875945 19.1432 2.35675L18.4277 3.07234C16.6196 1.76831 14.3995 1 12 1C5.92487 1 1 5.92487 1 12C1 13.8006 1.43263 15.5002 2.19962 17.0004C1.84009 17.3598 1.584 17.5254 1.40346 17.6365C0.507691 15.956 0 14.0373 0 12C0 5.37258 5.37258 0 12 0Z",
    fill: "#4D4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandCenterDefault);
export default __webpack_public_path__ + "static/media/Command_Center_Default.385df9daf2c0bb6229488a10a323eb19.svg";
export { ForwardRef as ReactComponent };